var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbaseWalletLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 500,
    fill: "#0052FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 500C150 693.3 306.7 850 500 850C693.3 850 850 693.3 850 500C850 306.7 693.3 150 500 150C306.7 150 150 306.7 150 500ZM410.556 387.222C397.669 387.222 387.222 397.669 387.222 410.556V589.444C387.222 602.331 397.669 612.778 410.556 612.778H589.444C602.331 612.778 612.778 602.331 612.778 589.444V410.556C612.778 397.669 602.331 387.222 589.444 387.222H410.556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseWalletLogoBg);
export default __webpack_public_path__ + "static/media/coinbase_wallet_logo_bg.a0e33fbbafa715a7ea0167e9c5b5fe9e.svg";
export { ForwardRef as ReactComponent };